import { createAction } from 'modules/helpers';

import { ActionTypes } from 'literals';

export const getDictionaries = createAction(ActionTypes.GET_DICTIONARIES, () => ({}));
// export const getEventTypes = createAction(PostbackActionTypes.GET_EVENT_TYPES, () => ({}));
